import React from 'react'
import FontAwesome from 'react-fontawesome'
import PaginationComponent from './../../../../../components/pagination/pagination.component'
import { downloadFromURL } from './../../../../../helpers/download.helper'
import { ClientReportsService } from './../../../../../services/client-reports.service'
import { PaymentStatus } from '../../../../../constants/ticket-sale.constants'
import { PAYMENT_METHODS } from '../../../../../constants/payment-method.constants'
import styled from 'styled-components'

const StyledSpan = styled.span`
	&:hover {
		.fa {
			transition: all 0.5s;
			color: #666 !important;
		}
	}
`

class PurchasePagination extends React.Component {
	componentWillReceiveProps(nextProps) {
		if (nextProps.forceReloadData !== this.props.forceReloadData) {
			this.refs.pagination.reload()
		}
	}
	render() {
		return (
			<PaginationComponent
				ref="pagination"
				headers={headers}
				rowsPerPage={100}
				sortable={sortable}
				params={this.props.params}
				getData={ClientReportsService.searchPurchases}
				renderRow={(rowData) => renderRow(rowData, this.props)}
			/>
		)
	}
}

function renderRow(rowData, props) {
	return headers.map(({ key, align }) => {
		const value = rowData[key]
		const isPaid = rowData.status == PaymentStatus.PAID
		const isCanceled = rowData.status == PaymentStatus.CANCELLED
		const isRebooking = rowData.status == PaymentStatus.REBOOKING
		const isNegativeValue = rowData.paymentType == 'Resgate' && value > 0
		const showTicketModal = rowData.description == 'Compra de passagem'
		const onClickRow = showTicketModal
			? () => {
					props
						.getPurchaseTickets(rowData.orderNumber)
						.then(props.openClientTicketModal)
			  }
			: null

		const onClickQrCode = () => {
			props.openQrCodeModal({
				pixImageQrCode: rowData.pixImageQrCode,
				pixEmv: rowData.pixEmv,
				pixValidity: rowData.pixValidity,
				provider: rowData.provider,
			})
		}

		switch (key) {
			case keys.STATUS:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span
							title={value}
							className={`${isCanceled || isRebooking ? 'danger' : ''}`}>
							{value}
						</span>
					</td>
				)
			case keys.VALUE:
				const valorNumerico = Number(value)
				const isNegative = !isNaN(valorNumerico) && valorNumerico < 0
				const valorFormatado =
					typeof valorNumerico.$toReais === 'function'
						? valorNumerico.$toReais()
						: valorNumerico.toLocaleString('pt-BR', {
								style: 'currency',
								currency: 'BRL',
						  })

				return (
					<td
						key={key}
						align={align}
						onClick={onClickRow}
						style={isNegative ? { color: 'green' } : undefined}>
						<span title={value}>{valorFormatado}</span>
					</td>
				)
			case keys.POINTS:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span
							title={value}
							className={`${isNegativeValue ? 'danger' : ''}`}>
							{isNegativeValue ? '-' : ''}
							{Number(value).toLocaleString('pt-BR')}
						</span>
					</td>
				)
			case keys.ACTIONS:
				const pdfLink = rowData.pdfHref
				const pixImageQrCode = rowData.pixImageQrCode
				const showPdfLink = !(pdfLink == null || isCanceled || isPaid)
				const showQrCode = !(
					pixImageQrCode == null ||
					isCanceled ||
					isPaid ||
					rowData.paymentType.toUpperCase() !==
						PAYMENT_METHODS.PIX.toUpperCase()
				)

				const BankSlipAction = showPdfLink ? (
					<StyledSpan
						title="Fazer download do boleto"
						onClick={() => {
							props.showLoading()
							downloadFromURL(
								pdfLink,
								`boleto-moveflex-pedido-${rowData.orderNumber}.pdf`
							)
								.then(props.hideLoading)
								.catch(props.hideLoading)
						}}>
						<FontAwesome name="file-o" />
					</StyledSpan>
				) : null

				const QrCodeAction = showQrCode ? (
					<StyledSpan
						title="Exibir QRCode para pagamento"
						onClick={onClickQrCode}>
						<FontAwesome name="qrcode" />
					</StyledSpan>
				) : null

				const TicketModalAction = showTicketModal ? (
					<StyledSpan
						title="Visualizar detalhes da viagem"
						style={{ marginLeft: 1 + 'em' }}
						onClick={onClickRow}>
						<FontAwesome name="ticket" />
					</StyledSpan>
				) : null

				return (
					<td key={key} align={align}>
						{QrCodeAction}
						{BankSlipAction}
						{TicketModalAction}
					</td>
				)
			default:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={value}>{value}</span>
					</td>
				)
		}
	})
}

const keys = {
	VALUE: 'value',
	POINTS: 'points',
	STATUS: 'status',
	ACTIONS: 'actions',
}

const headers = [
	{
		header: 'Data da compra',
		key: 'dateCreated',
		align: 'center',
	},
	{ header: 'Pedido', key: 'orderNumber', align: 'center' },
	{
		header: 'Meio de pagamento',
		key: 'paymentType',
		align: 'center',
	},
	{ header: 'Descrição', key: 'description' },
	{ header: 'Valor', key: keys.VALUE, align: 'right' },
	{ header: 'Pontos', key: keys.POINTS, align: 'center' },
	{ header: 'Situação', key: keys.STATUS },
	{ header: 'Ações', key: keys.ACTIONS, align: 'right' },
]

const sortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'orderNumber' },
		{ key: 'dateCreated' },
		{ key: 'value' },
		{ key: 'points' },
	],
}

export default PurchasePagination
